import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import { handleQueryParams, trackActiveRoute } from 'volta/utils/route-utils';

import type RouterService from '@ember/routing/router-service';
import type { RouteArgs } from '@ember/routing/lib/utils';

interface RouteIsActiveHelperSignature {
  Args: {
    Positional: RouteArgs;
  };
  Return: boolean;
}

export default class RouteIsActiveHelper extends Helper<RouteIsActiveHelperSignature> {
  @service router!: RouterService;

  compute(_params: RouteArgs, _named: unknown) {
    trackActiveRoute(this.router);

    const params = handleQueryParams(_params);

    return this.router.isActive(...params);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'route-is-active': typeof RouteIsActiveHelper;
  }
}
